export default __webpack_public_path__ + "static/media/password.ff48ccda.svg";